module.exports = __webpack_public_path__ + "static/media/kyc_verified.054ed8b7.png";